const courseOverview = {
  en: {
    // Loading / error states
    loading: 'Loading…',
    loadFailed: 'Failed to load course',
    noAccess: "You don't have access to this course.",
    notFound: 'Course not found.',
    publishStatusFailed: 'Failed to change publish status',
    deleteFailed: 'Failed to delete course',
    backToCourses: '← Back to courses',

    // Breadcrumb & hero actions
    breadcrumbAriaLabel: 'Breadcrumb',
    breadcrumbCourses: 'Courses',
    breadcrumbManage: 'Manage',
    unpublish: 'Unpublish',
    publishCourse: 'Publish course',
    publishByAdmin: 'An administrator publishes the course when it is ready.',
    statusPublished: 'Published',
    statusDraft: 'Draft',
    statusLive: 'Live',
    ownedByYou: 'Owned by you',
    free: 'Free',

    // Hero stat row
    statLessons: 'Lessons',
    statTestQuestions: 'Test questions',
    statStatus: 'Status',

    // Workspace tabs
    tabCurriculum: 'Curriculum',
    tabStudents: 'Students',
    tabRevenue: 'Revenue',
    tabAnalytics: 'Analytics',
    tabSettings: 'Settings',

    // Curriculum sub-category pills
    curriculumTypeAriaLabel: 'Content type',
    catLessons: 'Lessons',
    catModules: 'Modules',
    catTests: 'Tests',
    catGames: 'Games',
    catVocabulary: 'Vocabulary',
    catExams: 'Exams',

    // Settings — basic info
    settingsBasicInfoTitle: 'Basic information',
    settingsBasicInfoSub: 'The course identity students will see in the catalogue.',
    settingsCourseTitleLabel: 'Course title',
    settingsTitlePlaceholder: 'e.g. Russian for Beginners',
    settingsTitleTooLong: 'Title must be {max} characters or fewer.',
    settingsTitleRequired: 'Title is required.',
    settingsDescriptionLabel: 'Description',
    settingsDescriptionPlaceholder: 'What will students learn? Keep it short and engaging.',
    settingsDescriptionHelp: 'Shown on the course card and overview page.',
    charCounter: '{count}/{max}',

    // Settings — cover
    settingsCoverTitle: 'Course cover',
    settingsCoverSub: 'Pick a Darsly cover or upload your own image (16:9).',

    // Settings — difficulty
    settingsDifficultyTitle: 'Difficulty level',
    settingsDifficultySub: 'Helps learners pick the right course for their experience.',
    levelBeginner: 'Beginner',
    levelBeginnerSub: 'No prior knowledge needed',
    levelIntermediate: 'Intermediate',
    levelIntermediateSub: 'Some experience expected',
    levelAdvanced: 'Advanced',
    levelAdvancedSub: 'For experienced learners',

    // Settings — pricing
    settingsPricingTitle: 'Pricing',
    settingsPricingSub: 'Set a price or keep the course free for everyone.',
    tariffsTitle: 'Tariffs',
    tariffsSub: 'Price plans students pick at checkout. Each tariff saves on its own.',
    tariffsHelp: 'The course price follows the cheapest active tariff — now {price}.',
    tariffsHelpEmpty: 'No tariffs yet: the course is sold at the single price above.',
    tariffAdd: '+ Add tariff',
    tariffName: 'Name',
    tariffNamePlaceholder: 'e.g. Intizomli',
    tariffPrice: 'Price',
    tariffDescription: 'Description',
    tariffActive: 'Active',
    tariffDefault: 'Default',
    tariffSave: 'Save',
    tariffRetire: 'Retire',
    tariffRetireConfirm: 'Retire the "{name}" tariff? Past orders keep their record.',
    tariffSaved: 'Tariff "{name}" saved.',
    tariffSaveError: 'Could not save the tariff.',
    tariffsLoadError: 'Could not load the tariffs.',
    tariffNameError: 'A tariff name needs at least 2 characters.',
    tariffPriceError: 'A tariff price must be 0 or more.',
    settingsPriceFromTariffs: 'Set by the tariffs below — the cheapest active tariff.',
    settingsPriceLabel: 'Price',
    settingsPriceFreeHelp: 'This course is free for all students.',
    settingsPricePaidHelp: 'Students will be charged this amount on enrollment.',
    settingsMakeFreeLabel: 'Make this course free',
    switchPaid: 'Paid',

    // Settings — save bar
    settingsSaveError: 'Failed to save',
    settingsSaveSuccess: 'Changes saved',
    savebarDirty: 'You have unsaved changes',
    savebarClean: 'Up to date',
    discard: 'Discard',
    saving: 'Saving…',
    saveChanges: 'Save changes',

    // Settings — danger zone
    dangerZoneTitle: 'Danger zone',
    dangerZoneSub: 'Irreversible actions — proceed with care.',
    deleteThisCourse: 'Delete this course',
    deleteThisCourseDesc: 'Permanently remove the course along with its modules, lessons, tests, and enrollments.',
    deleteCourseBtn: 'Delete course',

    // Settings — advanced sections
    categoriesHeading: 'Categories',
    skillsPrerequisitesHeading: 'Skills & prerequisites',

    // Delete confirmation modal
    deleteModalTitle: 'Delete course',
    deleteModalBody: 'Are you sure you want to delete "{title}"? This also removes its lessons, tests, and enrollments.',
    cancel: 'Cancel',
    delete: 'Delete',

    // CourseCategories.js
    catLanguage: 'Language',
    catMathematics: 'Mathematics',
    catScience: 'Science',
    catProgramming: 'Programming',
    catDesign: 'Design',
    catBusiness: 'Business',
    catMarketing: 'Marketing',
    catMusic: 'Music',
    catArt: 'Art',
    catHistory: 'History',
    catOther: 'Other',
  },
  ru: {
    // Loading / error states
    loading: 'Загрузка…',
    loadFailed: 'Не удалось загрузить курс',
    noAccess: 'У вас нет доступа к этому курсу.',
    notFound: 'Курс не найден.',
    publishStatusFailed: 'Не удалось изменить статус публикации',
    deleteFailed: 'Не удалось удалить курс',
    backToCourses: '← Назад к курсам',

    // Breadcrumb & hero actions
    breadcrumbAriaLabel: 'Хлебные крошки',
    breadcrumbCourses: 'Курсы',
    breadcrumbManage: 'Управление',
    unpublish: 'Снять с публикации',
    publishCourse: 'Опубликовать курс',
    publishByAdmin: 'Курс публикует администратор, когда он готов.',
    statusPublished: 'Опубликован',
    statusDraft: 'Черновик',
    statusLive: 'В эфире',
    ownedByYou: 'Ваш курс',
    free: 'Бесплатно',

    // Hero stat row
    statLessons: 'Уроки',
    statTestQuestions: 'Вопросы тестов',
    statStatus: 'Статус',

    // Workspace tabs
    tabCurriculum: 'Программа',
    tabStudents: 'Студенты',
    tabRevenue: 'Доход',
    tabAnalytics: 'Аналитика',
    tabSettings: 'Настройки',

    // Curriculum sub-category pills
    curriculumTypeAriaLabel: 'Тип контента',
    catLessons: 'Уроки',
    catModules: 'Модули',
    catTests: 'Тесты',
    catGames: 'Игры',
    catVocabulary: 'Словарь',
    catExams: 'Экзамены',

    // Settings — basic info
    settingsBasicInfoTitle: 'Основная информация',
    settingsBasicInfoSub: 'Информация о курсе, которую увидят студенты в каталоге.',
    settingsCourseTitleLabel: 'Название курса',
    settingsTitlePlaceholder: 'например, «Русский для начинающих»',
    settingsTitleTooLong: 'Название должно содержать не более {max} символов.',
    settingsTitleRequired: 'Название обязательно.',
    settingsDescriptionLabel: 'Описание',
    settingsDescriptionPlaceholder: 'Чему научатся студенты? Опишите кратко и увлекательно.',
    settingsDescriptionHelp: 'Отображается на карточке курса и странице обзора.',
    charCounter: '{count}/{max}',

    // Settings — cover
    settingsCoverTitle: 'Обложка курса',
    settingsCoverSub: 'Выберите обложку Darsly или загрузите своё изображение (16:9).',

    // Settings — difficulty
    settingsDifficultyTitle: 'Уровень сложности',
    settingsDifficultySub: 'Помогает учащимся выбрать подходящий курс по уровню опыта.',
    levelBeginner: 'Начальный',
    levelBeginnerSub: 'Без предварительных знаний',
    levelIntermediate: 'Средний',
    levelIntermediateSub: 'Требуется некоторый опыт',
    levelAdvanced: 'Продвинутый',
    levelAdvancedSub: 'Для опытных учащихся',

    // Settings — pricing
    settingsPricingTitle: 'Стоимость',
    settingsPricingSub: 'Укажите цену или сделайте курс бесплатным для всех.',
    tariffsTitle: 'Тарифы',
    tariffsSub: 'Тарифы, которые студент выбирает при оплате. Каждый сохраняется отдельно.',
    tariffsHelp: 'Цена курса равна самому дешёвому активному тарифу — сейчас {price}.',
    tariffsHelpEmpty: 'Тарифов пока нет: курс продаётся по единой цене выше.',
    tariffAdd: '+ Добавить тариф',
    tariffName: 'Название',
    tariffNamePlaceholder: 'например, Intizomli',
    tariffPrice: 'Цена',
    tariffDescription: 'Описание',
    tariffActive: 'Активен',
    tariffDefault: 'По умолчанию',
    tariffSave: 'Сохранить',
    tariffRetire: 'Отключить',
    tariffRetireConfirm: 'Отключить тариф «{name}»? Прошлые заказы сохранятся.',
    tariffSaved: 'Тариф «{name}» сохранён.',
    tariffSaveError: 'Не удалось сохранить тариф.',
    tariffsLoadError: 'Не удалось загрузить тарифы.',
    tariffNameError: 'Название тарифа — минимум 2 символа.',
    tariffPriceError: 'Цена тарифа должна быть 0 или больше.',
    settingsPriceFromTariffs: 'Задаётся тарифами ниже — самый дешёвый активный тариф.',
    settingsPriceLabel: 'Цена',
    settingsPriceFreeHelp: 'Этот курс бесплатен для всех студентов.',
    settingsPricePaidHelp: 'При записи со студентов будет списана указанная сумма.',
    settingsMakeFreeLabel: 'Сделать курс бесплатным',
    switchPaid: 'Платно',

    // Settings — save bar
    settingsSaveError: 'Не удалось сохранить',
    settingsSaveSuccess: 'Изменения сохранены',
    savebarDirty: 'Есть несохранённые изменения',
    savebarClean: 'Всё сохранено',
    discard: 'Отменить',
    saving: 'Сохранение…',
    saveChanges: 'Сохранить изменения',

    // Settings — danger zone
    dangerZoneTitle: 'Опасная зона',
    dangerZoneSub: 'Необратимые действия — будьте осторожны.',
    deleteThisCourse: 'Удалить этот курс',
    deleteThisCourseDesc: 'Безвозвратно удаляет курс вместе с его модулями, уроками, тестами и записями студентов.',
    deleteCourseBtn: 'Удалить курс',

    // Settings — advanced sections
    categoriesHeading: 'Категории',
    skillsPrerequisitesHeading: 'Навыки и требования',

    // Delete confirmation modal
    deleteModalTitle: 'Удалить курс',
    deleteModalBody: 'Вы уверены, что хотите удалить «{title}»? Это также удалит его уроки, тесты и записи студентов.',
    cancel: 'Отмена',
    delete: 'Удалить',

    // CourseCategories.js
    catLanguage: 'Язык',
    catMathematics: 'Математика',
    catScience: 'Наука',
    catProgramming: 'Программирование',
    catDesign: 'Дизайн',
    catBusiness: 'Бизнес',
    catMarketing: 'Маркетинг',
    catMusic: 'Музыка',
    catArt: 'Искусство',
    catHistory: 'История',
    catOther: 'Другое',
  },
  uz: {
    // Loading / error states
    loading: 'Yuklanmoqda…',
    loadFailed: "Kursni yuklab bo'lmadi",
    noAccess: "Sizda ushbu kursga kirish huquqi yo'q.",
    notFound: 'Kurs topilmadi.',
    publishStatusFailed: "Nashr holatini o'zgartirib bo'lmadi",
    deleteFailed: "Kursni o'chirib bo'lmadi",
    backToCourses: '← Kurslarga qaytish',

    // Breadcrumb & hero actions
    breadcrumbAriaLabel: "Yo'l xaritasi",
    breadcrumbCourses: 'Kurslar',
    breadcrumbManage: 'Boshqarish',
    unpublish: 'Nashrdan olish',
    publishCourse: 'Kursni nashr qilish',
    publishByAdmin: "Kurs tayyor bo'lgach, uni administrator nashr qiladi.",
    statusPublished: 'Nashr qilingan',
    statusDraft: 'Qoralama',
    statusLive: 'Faol',
    ownedByYou: 'Sizning kursingiz',
    free: 'Bepul',

    // Hero stat row
    statLessons: 'Darslar',
    statTestQuestions: 'Test savollari',
    statStatus: 'Holat',

    // Workspace tabs
    tabCurriculum: 'Dastur',
    tabStudents: "O'quvchilar",
    tabRevenue: 'Daromad',
    tabAnalytics: 'Tahlil',
    tabSettings: 'Sozlamalar',

    // Curriculum sub-category pills
    curriculumTypeAriaLabel: 'Kontent turi',
    catLessons: 'Darslar',
    catModules: 'Modullar',
    catTests: 'Testlar',
    catGames: "O'yinlar",
    catVocabulary: "Lug'at",
    catExams: 'Imtihonlar',

    // Settings — basic info
    settingsBasicInfoTitle: "Asosiy ma'lumot",
    settingsBasicInfoSub: "O'quvchilar katalogda ko'radigan kurs ma'lumotlari.",
    settingsCourseTitleLabel: 'Kurs nomi',
    settingsTitlePlaceholder: "masalan, \"Boshlang'ichlar uchun rus tili\"",
    settingsTitleTooLong: 'Nom {max} belgidan oshmasligi kerak.',
    settingsTitleRequired: 'Nom kiritilishi shart.',
    settingsDescriptionLabel: 'Tavsif',
    settingsDescriptionPlaceholder: "O'quvchilar nimani o'rganadi? Qisqa va qiziqarli qilib yozing.",
    settingsDescriptionHelp: "Kurs kartochkasi va umumiy ko'rinish sahifasida ko'rsatiladi.",
    charCounter: '{count}/{max}',

    // Settings — cover
    settingsCoverTitle: 'Kurs muqovasi',
    settingsCoverSub: "Darsly muqovasini tanlang yoki o'z rasmingizni yuklang (16:9).",

    // Settings — difficulty
    settingsDifficultyTitle: 'Qiyinlik darajasi',
    settingsDifficultySub: "O'quvchilarga tajribasiga mos kursni tanlashda yordam beradi.",
    levelBeginner: "Boshlang'ich",
    levelBeginnerSub: 'Oldindan bilim talab qilinmaydi',
    levelIntermediate: "O'rta",
    levelIntermediateSub: "Ma'lum tajriba kerak",
    levelAdvanced: 'Yuqori',
    levelAdvancedSub: "Tajribali o'quvchilar uchun",

    // Settings — pricing
    settingsPricingTitle: 'Narx',
    settingsPricingSub: 'Narx belgilang yoki kursni hamma uchun bepul qiling.',
    tariffsTitle: 'Tariflar',
    tariffsSub: 'O\'quvchi to\'lovda tanlaydigan tariflar. Har biri alohida saqlanadi.',
    tariffsHelp: 'Kurs narxi eng arzon faol tarifga teng — hozir {price}.',
    tariffsHelpEmpty: 'Hozircha tarif yo\'q: kurs yuqoridagi yagona narxda sotiladi.',
    tariffAdd: '+ Tarif qo\'shish',
    tariffName: 'Nomi',
    tariffNamePlaceholder: 'masalan, Intizomli',
    tariffPrice: 'Narxi',
    tariffDescription: 'Tavsif',
    tariffActive: 'Faol',
    tariffDefault: 'Asosiy',
    tariffSave: 'Saqlash',
    tariffRetire: 'O\'chirish',
    tariffRetireConfirm: '«{name}» tarifini o\'chirasizmi? Oldingi buyurtmalar saqlanib qoladi.',
    tariffSaved: '«{name}» tarifi saqlandi.',
    tariffSaveError: 'Tarifni saqlab bo\'lmadi.',
    tariffsLoadError: 'Tariflarni yuklab bo\'lmadi.',
    tariffNameError: 'Tarif nomi kamida 2 ta belgidan iborat bo\'lsin.',
    tariffPriceError: 'Tarif narxi 0 yoki undan katta bo\'lishi kerak.',
    settingsPriceFromTariffs: 'Quyidagi tariflardan olinadi — eng arzon faol tarif.',
    settingsPriceLabel: 'Narx',
    settingsPriceFreeHelp: "Bu kurs barcha o'quvchilar uchun bepul.",
    settingsPricePaidHelp: "Ro'yxatdan o'tganda o'quvchilardan shu summa yechib olinadi.",
    settingsMakeFreeLabel: 'Kursni bepul qilish',
    switchPaid: 'Pullik',

    // Settings — save bar
    settingsSaveError: "Saqlab bo'lmadi",
    settingsSaveSuccess: "O'zgarishlar saqlandi",
    savebarDirty: "Saqlanmagan o'zgarishlar bor",
    savebarClean: 'Yangilangan',
    discard: 'Bekor qilish',
    saving: 'Saqlanmoqda…',
    saveChanges: "O'zgarishlarni saqlash",

    // Settings — danger zone
    dangerZoneTitle: 'Xavfli hudud',
    dangerZoneSub: "Qaytarib bo'lmaydigan amallar — ehtiyot bo'ling.",
    deleteThisCourse: "Bu kursni o'chirish",
    deleteThisCourseDesc: "Kursni uning modullari, darslari, testlari va ro'yxatdan o'tganlar bilan birga butunlay o'chiradi.",
    deleteCourseBtn: "Kursni o'chirish",

    // Settings — advanced sections
    categoriesHeading: 'Kategoriyalar',
    skillsPrerequisitesHeading: "Ko'nikmalar va talablar",

    // Delete confirmation modal
    deleteModalTitle: "Kursni o'chirish",
    deleteModalBody: '"{title}" kursini o\'chirishga ishonchingiz komilmi? Bu uning darslari, testlari va ro\'yxatdan o\'tganlarini ham o\'chiradi.',
    cancel: 'Bekor qilish',
    delete: "O'chirish",

    // CourseCategories.js
    catLanguage: 'Til',
    catMathematics: 'Matematika',
    catScience: 'Fan',
    catProgramming: 'Dasturlash',
    catDesign: 'Dizayn',
    catBusiness: 'Biznes',
    catMarketing: 'Marketing',
    catMusic: 'Musiqa',
    catArt: "San'at",
    catHistory: 'Tarix',
    catOther: 'Boshqa',
  },
};

export default courseOverview;
